module.exports = __webpack_public_path__ + "img/suhu_dan_kelembaban.0b1b6278.svg";